export default "__VITE_ASSET__BicaOwCj__"